import { ReactNode } from 'react'
import { cn } from '@/lib/utils/cn'

interface PageContainerProps {
  /** Content to render inside the container */
  children: ReactNode
  /** Maximum width constraint */
  maxWidth?: 'default' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | 'full'
  /** Additional CSS classes */
  className?: string
}

const maxWidthClasses = {
  default: '',
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  full: 'max-w-full',
}

export function PageContainer({ children, maxWidth = 'default', className }: PageContainerProps) {
  return (
    <div
      className={cn('container', maxWidth !== 'default' && maxWidthClasses[maxWidth], className)}
    >
      {children}
    </div>
  )
}
